/**
 * Very light platform detection from userAgent. Used to highlight the
 * right download card on the /app page. Safe fallback: "web".
 */
export function detectPlatform() {
  if (typeof navigator === "undefined") return "web";
  const ua = (navigator.userAgent || "").toLowerCase();

  if (/iphone|ipad|ipod/.test(ua))                      return "ios";
  if (/android tv|googletv/.test(ua))                   return "android_tv";
  if (/silk|kindle|fire tv/.test(ua))                   return "fire_tv";
  if (/apple ?tv|tvos/.test(ua))                        return "apple_tv";
  if (/smart-tv|smarttv|tizen/.test(ua))                return "samsung_tv";
  if (/webos|lg browser/.test(ua))                      return "lg_tv";
  if (/android/.test(ua))                               return "android";
  if (/mac os x/.test(ua) && !/mobile/.test(ua))        return "mac";
  if (/win(dows)? nt|win64|win32/.test(ua))             return "windows";
  return "web";
}

export const PLATFORMS = [
  { id: "android",     labelKey: "app.platform.android",     href: "#",
    note: "Google Play", icon: "android" },
  { id: "ios",         labelKey: "app.platform.ios",         href: "#",
    note: "App Store", icon: "apple" },
  { id: "android_tv",  labelKey: "app.platform.android_tv",  href: "#",
    note: "Play Store (TV)", icon: "tv" },
  { id: "fire_tv",     labelKey: "app.platform.fire_tv",     href: "#",
    note: "Amazon Appstore", icon: "tv" },
  { id: "apple_tv",    labelKey: "app.platform.apple_tv",    href: "#",
    note: "tvOS", icon: "apple" },
  { id: "samsung_tv",  labelKey: "app.platform.samsung_tv",  href: "#",
    note: "Tizen Store", icon: "tv" },
  { id: "lg_tv",       labelKey: "app.platform.lg_tv",       href: "#",
    note: "LG Content Store", icon: "tv" },
  { id: "windows",     labelKey: "app.platform.windows",     href: "#",
    note: ".exe", icon: "windows" },
  { id: "mac",         labelKey: "app.platform.mac",         href: "#",
    note: ".dmg", icon: "apple" },
];
